import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { rolesWith } from '../../utils/permissions';

/* "Import from Excel", on the lab pages, for the roles routes/bulk_import.py accepts.
 * kind="pitax" says "Import PITAX results" instead: it takes PITAX's export, not a sheet. */
export const IMPORT_ROLES = rolesWith('import:run');

export default function ImportLink({ kind }) {
  const { t } = useTranslation('import');
  const { user } = useAuth() || {};
  if (!(user?.roles || []).some(r => IMPORT_ROLES.includes(r))) return null;
  const pitax = kind === 'pitax';
  return (
    <Link to={`/import?kind=${kind}`} data-testid={`import-link-${kind}`}
          title={pitax ? t('tip.importPitaxLink') : t('tip.importLink')}
          style={{ fontSize: 13, color: 'var(--c-primary-fg)', border: '1px solid var(--c-primary)', borderRadius: 6,
                   padding: '5px 10px', textDecoration: 'none', whiteSpace: 'nowrap' }}>
      ⬆ {pitax ? t('fromPitax') : t('fromExcel')}
    </Link>
  );
}
